import {Injectable} from '@angular/core';
import {ParamMap, Params} from '@angular/router';

export interface MeetingFilterState {
  /** 'ALL' oder eine BU-Id. Ungeprüft, bis der Meeting-Modus den Wert gegen die geladenen BUs prüft. */
  bu: string;
  onlyOpen: boolean;
}

export const MEETING_FILTER_PARAMS: readonly string[] = ['bu', 'onlyOpen'];

export function defaultMeetingFilterState(): MeetingFilterState {
  return {bu: 'ALL', onlyOpen: true};
}

/** Gemerkte Filterauswahl des Meeting-Modus (NP20-984) — nur im Arbeitsspeicher, also bis zum Ende des Tabs. */
@Injectable({providedIn: 'root'})
export class MeetingFilterStateService {
  private state: MeetingFilterState = defaultMeetingFilterState();

  read(): MeetingFilterState {
    return {...this.state};
  }

  write(state: MeetingFilterState): void {
    this.state = {...state};
  }

  hasFilterParams(params: ParamMap): boolean {
    return MEETING_FILTER_PARAMS.some(key => params.has(key));
  }

  /** Jeder unbekannte Wert fällt still auf seinen Default zurück. */
  fromQueryParams(params: ParamMap): MeetingFilterState {
    return {
      bu: (params.get('bu') ?? '').trim() || 'ALL',
      onlyOpen: params.get('onlyOpen') !== '0',
    };
  }

  /** `null` entfernt den Parameter aus der Adresszeile; Defaults werden nie geschrieben. */
  toQueryParams(state: MeetingFilterState): Params {
    return {
      bu: state.bu !== 'ALL' ? state.bu : null,
      onlyOpen: state.onlyOpen ? null : '0',
    };
  }
}
